import BaseModule from '@/store/baseModule';
import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';
import makeListRequest from '@/store/modules/dashboardPem/makeListRequest';
import { treatsItems } from '@/business/apiTreatment/response/baseAPITreatment';

const attributesObjRef = {};
const attributesObj = {
  entity_nav_full_id: {
    type: '$instr',
    values: [],
  },
  current_action_status_type_id: {
    type: '$idlists',
    values: [],
  },
  staffs_in_charge_id: {
    type: '$idlists',
    values: [],
  },
  list_params: {
    type: '$parameters',
    values: [
      {
        origin: 'current_action_status_type_id',
        transformed: 'action_status_ids',
      },
      { origin: 'staffs_in_charge_id', transformed: 'person_in_charge_ids' },
    ],
  },
};
const dateFilter = new Date();
dateFilter.setDate(new Date().getDate() - 14);

export default (store) => {
  store.registerModule(
    ['actionplans', 'light'],
    new BaseModule({
      serviceAPI: new BaseService({
        api: new BaseAPI({
          url: `${process.env.MYPREDITY_BASE_URI}/actionplans?light=O`,
        }),
        treatListResponse: treatsItems({
          datetimeFieldNames: [
            'creation_datetime',
            'start_datetime',
            'end_datetime',
            {
              arrayFieldName: 'action_plan_origins',
              arrayFields: ['datetime'],
            },
          ],
        }),
      }),
      attributesObj,
      attributesObjRef,
      dateMin: dateFilter,
      makeQueryParams: makeListRequest,
    })
  );

  const DEFAULT_COPIED_FILTERS = [
    'entity_nav_full_id',
    'staffs_in_charge_id',
    'action_plan_status',
  ];

  store.subscribeAction((action) => {
    if (action.type === 'dashboardPem/setFilterAttribute') {
      if (
        DEFAULT_COPIED_FILTERS.find((item) => item === action.payload.attribute)
      ) {
        store.dispatch('actionplans/light/setFilterAttribute', {
          ...action.payload,
          reload: false,
        });
      } else if (action.payload.attribute === 'action_status_id') {
        store.dispatch('actionplans/light/setFilterAttribute', {
          ...action.payload,
          attribute: 'current_action_status_type_id',
          reload: false,
        });
      }
    }
  });
};
